var cifPe = ["301 201", "<g fill='none'><path fill='#D91023' d='M.5.5h300v200H.5z'/><path fill='#FFF' d='M100.5.5h100v200h-100z'/></g>"];

export { cifPe };

